export const CANDIDATE_STAGES = [
  ['applied', 'Applied'], ['screening', 'Screening'], ['interview', 'Interview'],
  ['offer_approved','Offer approved'], ['offered', 'Offer sent'], ['accepted', 'Offer accepted'], ['joined', 'Joined'], ['on_hold','On hold'], ['rejected','Rejected by HR'], ['offer_declined','Offer declined'], ['terms_requested','Revised terms requested'], ['withdrawn','Candidate withdrawn'], ['archived', 'Archived'],
];
export function candidateStage(candidate) {
  if (candidate.converted_employee_id || candidate.converted_emp_id) return 'joined';
  return candidate.stage === 'hired' ? 'accepted' : candidate.stage || 'applied';
}
export const stageLabel = candidate => CANDIDATE_STAGES.find(([key]) => key === candidateStage(candidate))?.[1] || candidateStage(candidate);
export const CLEARANCE_ITEMS = [['it_assets', 'IT assets returned'], ['id_badge', 'ID / access card returned'], ['email_revoked', 'Work account access closed'], ['accounts_cleared', 'Finance clearance']];
export function exitStatus(exit, employee) {
  return exit?.status === 'relieved' || ['relieved', 'terminated'].includes(employee?.employment_status) ? 'relieved' : 'in_notice';
}
export const paymentStatus = settlement => settlement?.payment_status === 'paid' ? 'Paid' : settlement?.status === 'draft' ? 'Draft' : 'Pending';
export function settlementTotals(form) {
  const n = key => Math.max(0, Number(form[key]) || 0);
  const unpaidSalary = Math.round(n('last_gross') / 30 * n('payable_days'));
  const leaveEncashment = Math.round(n('basic_salary') / 26 * n('leave_balance'));
  const gratuity = n('gratuity_years') >= 5 ? Math.round(15 * n('basic_salary') * n('gratuity_years') / 26) : 0;
  const noticeRecovery = Math.round(n('last_gross') / 30 * n('shortfall_days'));
  const totalEarnings = unpaidSalary + leaveEncashment + gratuity + n('bonus');
  const totalDeductions = noticeRecovery + n('advance_recovery') + n('asset_recovery') + n('statutory_deductions');
  return { unpaidSalary, leaveEncashment, gratuity, noticeRecovery, totalEarnings, totalDeductions, netPayable: Math.max(0, totalEarnings - totalDeductions) };
}
export const isActiveInterviewer = employee => employee.is_active !== false && !['relieved', 'terminated'].includes(employee.employment_status);
export function validateResume(file) {
  if (!file) return '';
  if (!/\.(pdf|docx?)$/i.test(file.name)) return 'Choose a PDF, DOC or DOCX resume.';
  if (!file.size || file.size > 4 * 1024 * 1024) return 'Resume must be between 1 byte and 4 MB.';
  return '';
}

export const INTERVIEW_RECOMMENDATIONS = [
 ['proceed','Continue to next round'],['offer','Recommend an offer'],['reject','Not suitable / do not proceed'],['hold','Hold / needs discussion'],
];
export const interviewRecommendationLabel = value => INTERVIEW_RECOMMENDATIONS.find(([key])=>key===value)?.[1] || value || 'Not recorded';
